import { backendApi } from "./axios";
import { GRADE_MANAGEMENT_ENDPOINTS } from "./endpoints";

export function getGrades(params) {
  return backendApi.get(GRADE_MANAGEMENT_ENDPOINTS.GET_ALL, { params });
}